import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { GenericFieldModule } from '@app/core/globals/generic-field/generic-field.module';
import { ContractorFieldComponent } from './contractor-field.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    GenericFieldModule,
  ],
  declarations: [
    ContractorFieldComponent,
  ],
  exports: [
    ContractorFieldComponent,
  ],
})
export class ContractorsExportModule {}
